module.exports = __webpack_public_path__ + "img/syukyaku-syukyaku-002sp.1e1c9c7f.jpg";